import { Button, Form, Space } from "antd";
import { useState } from "react";
import _t from "../../lang/translate";
import { updateRiskAssessment } from "../../services/leasingService";
import { AcceptValidationType } from "../../types/leasingTypes";
import { OpenModalProps } from "../../types/modalTypes";
import assertFC from "../../utilities/assertFC";
import EnumSelect from "../form/enumSelect";
import { renderErrorMessage } from "../messages/errorMessage";

export default function LeasingUpdateRiskAssessment<T extends object>({ onSuccess, onCancel, payload }: OpenModalProps<T>) {
  const [tmpForm] = Form.useForm<AcceptValidationType>();
  const [loading, setLoading] = useState<boolean>(false);
  const handleAccept = async (values: any) => {
    const { id } = payload;
    try {
      setLoading(true);
      const { data } = await updateRiskAssessment(id, { riskAssessment: values.riskAssessment ?? null });
      onSuccess(data as T);
    } catch (error) {
      renderErrorMessage(error)
      setLoading(false);
    }
  };

  return (
    <Form form={tmpForm} requiredMark={false} layout="horizontal" onFinish={handleAccept} initialValues={{}}>
      <h2 className="modal-title">{_t("update", "riskClassification")}</h2>
      <Form.Item labelAlign="left" name="riskAssessment" label={_t("riskClassification")} >
        <EnumSelect nameKey={['leasingCase', 'riskAssessment']} allowClear />
      </Form.Item>
      <div className="text-right">
        <Space>
          <Button type="ghost" onClick={onCancel} disabled={loading}>
            {_t("cancel")}
          </Button>
          <Button htmlType="submit" loading={loading} type="primary">
            {_t("accept")}
          </Button>
        </Space>
      </div>
    </Form>
  );
}

assertFC(LeasingUpdateRiskAssessment);
